import {
  SHOW_LOGS,
  DEFAULT_LOG_TEMPLATE
} from '../constants';

const Evented = Object.preventExtensions({
  on()      {window.$(this).on(...arguments);},
  one()     {window.$(this).one(...arguments);},
  off()     {window.$(this).off(...arguments);},
  trigger() {
    SHOW_LOGS && console.log(DEFAULT_LOG_TEMPLATE, 'Evented::trigger', ...arguments);
    window.$(this).trigger(...arguments);
  }
});

export default Evented;


// WEBPACK FOOTER //
// ./src/mixins/evented.js